import ReactDOM from "react-dom";

const portal = document.createElement("div");
document.body.appendChild(portal);

const Portal: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return ReactDOM.createPortal(children, portal);
};

export default Portal;